import React, { Fragment, useEffect, useState } from "react";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import styles from "./Cart.module.css";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link } from "react-router-dom";
import Parse from "../../API/ParseServer";
const ArtworkItem: React.FC<{
  item: any;
  pricing: any;
  updateTotal: any;
  artworkQuantities: any;
  loseDiscount: any;
}> = (props) => {
  const [inputQuantity, setInputQuantity] = useState(
    Number(props.item.quantity)
  );
  const [quantity, setQuantity] = useState(props.item.artwork.get("quantity"));
  const [reservedQuantity, setReservedQuantity] = useState(
    props.item.artwork.get("reservedQuantity")
  );

  const [quantityloading, setQuantityloading] = useState(false);
  const uid = function () {
    return (
      Date.now().toString(36) +
      Math.floor(
        Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12)
      ).toString(36)
    );
  };
  const guestId = localStorage.getItem("guestId")
    ? localStorage.getItem("guestId")
    : uid();
  const quantityDecHandler = async () => {
    const user = Parse.User.current();
    let response;
    if (
      inputQuantity !== 1 &&
      !quantityloading &&
      (user || localStorage.getItem("guestId")) &&
      (await props.loseDiscount(props.item.itemId, false))
    ) {
      setQuantityloading(true);
      try {
        if (user)
          response = await Parse.Cloud.run("addToBasket", {
            user: user.id,
            artworkId: artwork.id,
            quantity: inputQuantity - 1,
            frameId: "",
            specifications: {
              mountboard: {},
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "Artwork",
            itemId: props.item.itemId,
          });
        else {
          response = await Parse.Cloud.run("addToBasket", {
            user: guestId,
            artworkId: artwork.id,
            quantity: inputQuantity - 1,
            frameId: "",
            specifications: {
              mountboard: {},
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "Artwork",
            itemId: props.item.itemId,
          });
          if (guestId) localStorage.setItem("guestId", guestId);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (response) setInputQuantity((current) => current - 1);
        setQuantityloading(false);
        props.updateTotal();
      }
    }
  };

  const quantityIncHandler = async () => {
    const user = Parse.User.current();
    let response;
    if (
      (props.artworkQuantities[artwork.id] || 0) < quantity &&
      !quantityloading &&
      (user || localStorage.getItem("guestId"))
    ) {
      // console.log(props.artworkQuantities[artwork.id]);
      setQuantityloading(true);
      try {
        if (user)
          response = await Parse.Cloud.run("addToBasket", {
            user: user.id,
            artworkId: artwork.id,
            quantity: inputQuantity + 1,
            frameId: "",
            specifications: {
              mountboard: {},
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "Artwork",
            itemId: props.item.itemId,
          });
        else {
          response = await Parse.Cloud.run("addToBasket", {
            user: guestId,
            artworkId: artwork.id,
            quantity: inputQuantity + 1,
            frameId: "",
            specifications: {
              mountboard: {},
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "Artwork",
            itemId: props.item.itemId,
          });
          if (guestId) localStorage.setItem("guestId", guestId);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (response) setInputQuantity((current) => current + 1);
        setQuantityloading(false);
        props.updateTotal();
      }
    }
  };
  const deleteHandler = async () => {
    const user = Parse.User.current();
    let response;
    if (
      (user || localStorage.getItem("guestId")) &&
      (await props.loseDiscount(props.item.itemId, true))
    ) {
      try {
        if (user)
          response = await Parse.Cloud.run("addToBasket", {
            user: user.id,
            artworkId: artwork.id,
            quantity: 0,
            frameId: "",
            specifications: {
              mountboard: {},
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "Artwork",
            itemId: props.item.itemId,
          });
        else {
          response = await Parse.Cloud.run("addToBasket", {
            user: guestId,
            artworkId: artwork.id,
            quantity: 0,
            frameId: "",
            specifications: {
              mountboard: {},
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "Artwork",
            itemId: props.item.itemId,
          });
          if (guestId) localStorage.setItem("guestId", guestId);
        }
      } catch (error) {
        console.log(error);
      } finally {
        localStorage.removeItem("artworkItemId");
        if (response) window.location.reload();
        props.updateTotal();
      }
    }
  };
  const artwork = props.item.artwork;
  const VAT = props.pricing ? props.pricing.get("VAT") : 0.2;
  function addCommas(num: number | String) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return (
    <Grid sx={{ width: "100%", borderBottom: "2px solid #f3f4f5" }} container>
      <Grid md={4} xs={12} item sx={{ py: 4 }}>
        {artwork.get("thumbnail") ? (
          <img
            src={artwork.get("thumbnail").url()}
            alt={artwork.get("title")}
            style={{ width: "100%" }}
          />
        ) : (
          <Box
            sx={{
              width: "100%",
              aspectRatio: 1,
              backgroundColor: "gray",
            }}
          ></Box>
        )}
      </Grid>

      <Grid
        item
        md={7.8}
        xs={12}
        sx={{
          py: 4,
          mt: { xs: 2, md: 0 },
          px: 1,
          pl: { md: 4 },
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: "1000" }} component="h2">
          {props.item.title}
        </Typography>
        <Typography variant="h6">By {artwork.get("artist")}</Typography>
        <Grid
          sx={{
            display: "flex",
            py: 1,
            borderBottom: "2px solid #f3f4f5",
            width: "100%",
            alignItems: "center",
          }}
          container
        >
          <Grid item xs={7}>
            <Typography variant="subtitle1" sx={{ width: "20rem" }}>
              Artwork Dimensions
            </Typography>
          </Grid>
          <Grid item xs={5}>
            <Typography variant="subtitle1">
              {artwork.get("width")} x {artwork.get("height")} cm
            </Typography>
          </Grid>
        </Grid>

        <Grid
          sx={{
            display: "flex",
            py: 1,
            borderBottom: "2px solid #f3f4f5",
            width: "100%",
            alignItems: "center",
          }}
          container
        >
          <Grid item xs={7}>
            <Typography variant="subtitle1" sx={{ width: "20rem" }}>
              Quantity
            </Typography>
          </Grid>

          <Grid sx={{ display: "flex", gap: 1 }} item xs={5}>
            <button
              className={
                inputQuantity === 1
                  ? styles["quantity-disable"]
                  : styles["quantity-button"]
              }
              onClick={quantityDecHandler}
              disabled={inputQuantity === 1}
            >
              -
            </button>
            <Typography
              sx={{
                border: "2px solid #8d462b",
                borderRadius: 2,
                p: "2px 10px",
                width: "2.5rem",
                textAlign: "center",
              }}
            >
              {inputQuantity}
            </Typography>
            <button
              className={
                (props.artworkQuantities[artwork.id] || 0) >= quantity
                  ? styles["quantity-disable"]
                  : styles["quantity-button"]
              }
              onClick={quantityIncHandler}
              disabled={(props.artworkQuantities[artwork.id] || 0) >= quantity}
            >
              +
            </button>
          </Grid>
        </Grid>

        <br />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "end",
          }}
        >
          <Box>
            <button className={styles["edit-button"]} onClick={deleteHandler}>
              <DeleteIcon sx={{ fontSize: "27px", mr: 1 }} /> Delete
            </button>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
            }}
          >
            <Typography component="h2" variant="h4">
              £{addCommas(artwork.get("price") * inputQuantity)}
            </Typography>
            <Typography sx={{ color: "gray", mt: 1 }} variant="subtitle2">
              {" "}
              incl. £
              {addCommas(
                (artwork.get("price") * inputQuantity * Number(VAT)).toFixed(2)
              )}{" "}
              VAT
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ArtworkItem;
